import { LoaderComponent } from 'src/app/components/widgets/loader/loader.component';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EmployeeConsultantsService } from '../../../../services/api/hr/employee-consultants.service';
import { EmployeeConsultantsResidentialInfoFormComponent } from '../components/employee-consultants-residential-info-form/employee-consultants-residential-info-form.component';
import { EmployeeConsultantsGeneralInfoFormComponent } from '../components/employee-consultants-general-info-form/employee-consultants-general-info-form.component';
import { EmployeeConsultantsPreviousJobsFormComponent } from '../components/employee-consultants-previous-jobs-form/employee-consultants-previous-jobs-form.component';
import { FormNotesCustomersComponent } from 'src/app/modules/customers/components/notes-customers-form/notes-customers-form.component';
import { AlertInfo } from '../../../../models/alert-info';
import { HttpParams } from '@angular/common/http';
import { EmployeeDocumentsComponent } from '../components/employee-documents/employee-documents.component';

@Component({
  selector: 'app-employee-consultants-detail-page',
  imports: [
    EmployeeConsultantsResidentialInfoFormComponent,
    EmployeeConsultantsGeneralInfoFormComponent,
    EmployeeConsultantsPreviousJobsFormComponent,
    FormNotesCustomersComponent,
    EmployeeDocumentsComponent,
    LoaderComponent
],
  templateUrl: './employee-consultants-detail-page.component.html',
  styleUrl: './employee-consultants-detail-page.component.scss'
})
export class EmployeeConsultantsDetailPageComponent implements OnInit {
  employeeId!: number;
  employee: any;
  employeeWorkCustomerList: any[] = [];
  loading = true;
  error: string | null = null;
  readonly = true; 
  alertInfo: AlertInfo = { show: false, type: 'success', message: '' };

  constructor(
    private route: ActivatedRoute,
    protected employeeConsultantsService: EmployeeConsultantsService
  ) {}

  ngOnInit(): void {
    this.employeeId = Number(this.route.snapshot.paramMap.get('employeeId'));
    if (this.employeeId) {
      this.loadData(this.employeeId);
      console.log(this.employeeId);
      
    }
  }

  loadData(employeeId: number): void {
    this.loading = true;
    const params = new HttpParams().set('size', '9999');
    
    this.employeeConsultantsService.detail(employeeId).subscribe(
      (response: any) => {
        if (response?.data) {
          this.employee = response.data.employee;
          this.loading = false;
        } else {
          this.error = 'Employee data not available';
          this.loading = false;
        }
      },
      (error) => {
        this.error = 'Error loading data';
        this.loading = false;
        console.error('Error loading employee data:', error);
      }
    );

     this.employeeConsultantsService.listEmployeeJobs(employeeId).subscribe((response: any) => {
      if (response?.data?.employeeJobs) {
        this.employeeWorkCustomerList = response.data.employeeJobs || [];
      }
    });
  }
  
  loadEmployeeWorkCustomerList(): void {
    if (this.employeeWorkCustomerList.length === 0 && this.employee?.employeeWorkList) {
      const customerIds = new Set<number>();
      this.employee.employeeWorkList.forEach((work: any) => {
        if (work.customer && work.customerId) {
          customerIds.add(work.customerId);
        }
      });
      
      this.employeeWorkCustomerList = Array.from(customerIds).map(id => {
        const work = this.employee.employeeWorkList.find((w: any) => w.customerId === id);
        return work?.customer || { customerId: id, companyName: 'Unknown' };
      });
    }
  }
}
